"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getTag_js_1 = __importDefault(require("./.internal/getTag.js"));
const nodeTypes_js_1 = __importDefault(require("./.internal/nodeTypes.js"));
const isObjectLike_js_1 = __importDefault(require("./isObjectLike.js"));
/** Used to match `toStringTag` values of typed arrays. */
const reTypedTag = /^\[object (?:Float(?:32|64)|(?:Int|Uint)(?:8|16|32)|Uint8Clamped)Array\]$/;
/* Node.js helper references. */
const nodeIsTypedArray = nodeTypes_js_1.default && nodeTypes_js_1.default.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * isTypedArray(new Uint8Array)
 * // => true
 *
 * isTypedArray([])
 * // => false
 */
const isTypedArray = nodeIsTypedArray
    ? (value) => nodeIsTypedArray(value)
    : (value) => (0, isObjectLike_js_1.default)(value) && reTypedTag.test((0, getTag_js_1.default)(value));
exports.default = isTypedArray;
